import { KEYBOARD } from '../../../../constants/index.js';
import { useTabManager } from './useTabManager/useTabManager.js';

function useTabProps(tabId) {
  var _useTabManager = useTabManager(),
    setActiveTab = _useTabManager.setActiveTab,
    activeTab = _useTabManager.activeTab,
    navigateToNextTab = _useTabManager.navigateToNextTab,
    navigateToPreviousTab = _useTabManager.navigateToPreviousTab,
    tabGroupId = _useTabManager.tabGroupId;
  var isActive = activeTab === tabId;
  var htmlId = tabGroupId + "-" + tabId;
  var tabIndex = isActive ? 0 : -1;
  var handleClick = function handleClick() {
    setActiveTab(tabId);
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (!isActive) {
      return;
    }
    if (e.key === KEYBOARD.ARROW_RIGHT) {
      e.preventDefault();
      navigateToNextTab();
    } else if (e.key === KEYBOARD.ARROW_LEFT) {
      e.preventDefault();
      navigateToPreviousTab();
    }
  };
  var tabProps = {
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    tabIndex: tabIndex,
    role: 'tab',
    id: htmlId,
    'data-tab-id': tabId
  };
  return {
    tabProps: tabProps
  };
}

export { useTabProps };
